// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';
import { getIconPath } from '@tcp/core/src/utils';

const JeansModuleStyles = css`
  position: relative;
  overflow-y: hidden;
  border: 1px solid ${(props) => props.theme.colorPalette.gray[400]};
  margin: 0 -14px ${(props) => props.theme.spacing.ELEM_SPACING.XL} -14px;
  .jeans-carousel {
    background: ${(props) => props.theme.colorPalette.gray[300]};
    overflow: hidden;
  }
  .image-link {
    .carousel-image {
      margin: 0 auto;
      display: block;
      opacity: 1;
      @media ${(props) => props.theme.mediaQuery.large} {
        height: auto;
      }
    }
  }
  .title-section {
    width: 463px;
    height: 30px;
    background: ${(props) => props.set[1].val};
    position: absolute;
    bottom: -30px;
    left: 0;
    margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    transform: rotate(270deg);
    transform-origin: 0 0;
    line-height: 30px;
    text-decoration: uppercase;
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      width: 408px;
      margin-left: 0px;
    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      width: 313px;
      margin-left: 0px;
    }
    @media (min-width: 1200px) and (max-width: 1440px) {
      margin-left: 0;
      width: 400px;
    }
  }
  .image-text {
    height: 36px;
    border-top: 1px solid ${(props) => props.theme.colorPalette.gray[900]};
    background: #abdedc;
    text-align: center;
    line-height: 38px;
    width: 96%;
    margin: 0 auto;
    text-transform: uppercase;
    color: #134f73;
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs13};
    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs12};
      width: 100%;
      margin: 0;
    }
  }
  .text-subheader {
    width: 70%;
    margin: 0 auto 10px;
  }
  .tcp_carousel_wrapper {
    margin-left: 44px;
  }

  .overlapping-section,
  .plus-button {
    display: none;
  }
  .slick-slide > div {
    padding: 0 6px;
  }

  @media ${(props) => props.theme.mediaQuery.medium} {
    margin: 0 0 ${(props) => props.theme.spacing.ELEM_SPACING.XL} 0;
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    .plus-icon {
      display: block;
      position: absolute;
      bottom: 167px;
      .left {
        left: 17px;
      }
      right: 17px;
    }

    .jeans-carousel:hover {
      position: relative;

      .overlapping-section {
        display: none;
        position: absolute;
        top: 0;
        height: 100%;
        width: 100%;
      }
    }
    .text-container {
      .text-line img {
        display: inline-block;
        vertical-align: middle;
      }
      .text-item {
        display: inline;
      }
    }
    .done-button {
      width: 20px;
      margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    }
    .shop-now-link {
      position: absolute;
      bottom: 0;
      background: ${(props) => props.set[1].val};
      color: white;
      width: 100%;
      height: 38px;
      line-height: 38px;
      left: 0;
      font-weight: ${(props) => props.theme.typography.fontWeights.extrabold};
    }

    .text-header {
      margin: 19px 0 ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    }
    .text-subheader {
      margin-bottom: 16px;
    }
    .text-line {
      text-align: left;
      margin: 0 ${(props) => props.theme.spacing.ELEM_SPACING.REG} 12px;
    }
    .slick-prev,
    .slick-next {
      width: 48px;
      height: 48px;
      z-index: 1;
      border-radius: 30px;
      margin-left: 6px;
      background-color: white;
      background-image: url('${(props) => getIconPath('carrot-left-light-gray', props)}');
      background-repeat: no-repeat;
      background-position: center center;
      align-content: center;
    }
    .slick-prev {
      margin-left: 6px;
      transform: rotate(0deg) translate(0, -50%);
    }
    .slick-next {
      transform: rotate(180deg) translate(0, -50%);
      transform-origin: 24px 0;
    }
  }

  @media (min-width: 1200px) and (max-width: 1440px) {
    .tcp_carousel_wrapper {
      margin-left: 30px;
    }
  }

  .smooth-scroll-list {
    margin-left: 44px;
    display: flex;
    overflow-x: auto;
  }

  .smooth-scroll-list::-webkit-scrollbar {
    display: none;
  }

  .smooth-scroll-list-item {
    margin: 0 6px;
    width: 130px !important;
    flex-shrink: 0;
    height: 100%;
    @media (min-width: 768px) and (max-width: 1199px) {
      width: 151px !important;
    }
  }

  .slick-track {
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      width: 900px;
    }
  }
  .slick-slide {
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      width: 15% !important;
    }
  }
  .plus-icon {
    display: none;
  }

  @media (min-width: 1150px) {
    .jeans-carousel {
      background: #b8e0e1;
    }
  }
`;
/* ToDo: Above important can be removed once the override from
  bootstract css is removed in prod

  @media screen and (max-width: 767px)
  <style>
  .jeans-carousel {
      width: 100% !important;
    }
*/

export const Container = styled.div`
  .aspect-ratio-box-v1 {
    height: 0;
    overflow: hidden;
    position: relative;
    padding-top: 193%;
  }
  .aspect-ratio-box-inside {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 100%;
    }
  }
  ${(props) =>
    props.isV2DesignEnabled
      ? `
  .jeans-module {
    max-width: 1440px;
  }
  border: none;
  .tcp_carousel_wrapper {
    margin-left: 0;
  }
  .jeans-carousel,
  .image-text {
    background: none;
  }
  .image-text {
    border-top: 0;
  }
  .slick-prev,
  .slick-next {
    padding: 0 ${props.theme.spacing.ELEM_SPACING.LRG};
    top: 40%;
  }
  .slick-disabled {
    display: none !important;
  }
  .smooth-scroll-list {
    margin-left: 0;
  }
  .aspect-ratio-box {
    height: 0;
    overflow: hidden;
    position: relative;
    padding-top: 186%;
  }
  .aspect-ratio-box-inside {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    @media ${props.theme.mediaQuery.large} {
      min-height: 420px;
    }

  }
`
      : ''};
`;

export const SmoothScrollWrapper = styled.div`
  ${(props) =>
    props.isItemLengthLessThanSix
      ? `
    @media (min-width: 768px) and (max-width: 1199px) {
      justify-content: center;
    }
  `
      : ``}
`;

export default JeansModuleStyles;
